import { withTypeSafeApiResult } from '@/packages/typesafe-result';

import {
  type IRegionalDistrictsGetByLocationIdRequest,
  type IRegionalDistrictsGetByLocationIdResponse,
  fetchRegionalDistrictsGetByLocationId,
} from '@/repositories/generated/shared/geo/v1/regional-districts/get-by-location-id';

export const fetchRegionalDistricts = withTypeSafeApiResult<
  IRegionalDistrictsGetByLocationIdRequest,
  IRegionalDistrictsGetByLocationIdResponse
>(fetchRegionalDistrictsGetByLocationId);
